module.exports = __webpack_public_path__ + "img/4icon@2x.d08b1d67.png";